// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/views/jobs/searches/useSearchesConfig.js
//
// Charge UNE fois GET /api/member-searches/config (plafonds, périmètre proposé, motifs).
// Source de vérité : le backend. Tant que la config n'est pas là, le formulaire reste utilisable
// (aucun plafond de saisie côté interface : le serveur valide de toute façon).

import { useEffect, useState } from 'react'
import { fetchConfig } from '../../../utils/memberSearchesApi'

const useSearchesConfig = () => {
  const [config, setConfig] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false
    fetchConfig()
      .then((data) => {
        if (!cancelled) setConfig(data)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { config, failed }
}

export default useSearchesConfig
